export const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

export const money2 = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// PAYMENT_MODE -> Payment Mode. Names typed by people (categories etc.) are shown exactly as written.
const ACRONYMS = new Set(['UPI', 'DD', 'NEFT', 'RTGS', 'IMPS', 'IT', 'GST', 'TDS', 'PF', 'ESI']);
export const label = (s) => {
  const t = String(s || '');
  if (!t || /[a-z]/.test(t)) return t;
  return t.replace(/_/g, ' ').split(' ').map((w) => (ACRONYMS.has(w) ? w : w.charAt(0) + w.slice(1).toLowerCase())).join(' ');
};

export const pct = (v) => (v === null || v === undefined ? '-' : `${Number(v).toFixed(1)}%`);

export const errorText = (e, fallback = 'Something went wrong. Please try again.') =>
  e?.response?.data?.message || (e?.response?.status === 403 ? 'You do not have permission to do this.' : fallback);
